// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__1CLTm","name":"ConsentHeader_name__-hkBW","birthday":"ConsentHeader_birthday__3Zj88","skeleton":"ConsentHeader_skeleton__jjhG5"};